import { Text } from '@loadsmart/loadsmart-ui'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import styled from 'styled-components'

const StyledLink = styled(Text)`
  line-height: inherit;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`

export interface ConditionalCallableLinkProps {
  label: string
  onClick?: () => void
}

const ConditionalCallableLink = (props: ConditionalCallableLinkProps) => {
  return props.onClick ? (
    <StyledLink variant="link" onClick={props.onClick}>
      {props.label}
      <OpenInNewIcon fontSize="inherit" />
    </StyledLink>
  ) : (
    <Text onClick={props.onClick}>{props.label}</Text>
  )
}

export default ConditionalCallableLink
